/**
 * Datora Discount Entry — UI component for the discount code input in the cart drawer.
 * Uses floating-label pattern: active code displayed inside the field.
 * Loaded before datora.js so functions are available globally.
 */

/**
 * Show the active discount code in the floating-label field.
 */
function showActiveDiscountCode(code) {
  const container = document.querySelector('.datora-discount-field-container');
  if (!container) return;
  const cleanCode = code.trim().toUpperCase();

  container.setAttribute('data-discount-state', 'active');

  const removeBtn = container.querySelector('.datora-remove-btn');
  if (removeBtn) removeBtn.removeAttribute('hidden');

  const input = container.querySelector('#Cart-DiscountCode');
  if (input) {
    input.value = cleanCode;
  }
}

/**
 * Clear the active discount code display, return to empty state.
 */
function clearActiveDiscountCode() {
  const container = document.querySelector('.datora-discount-field-container');
  if (!container) return;

  container.setAttribute('data-discount-state', 'empty');

  const removeBtn = container.querySelector('.datora-remove-btn');
  if (removeBtn) removeBtn.setAttribute('hidden', '');

  const input = container.querySelector('#Cart-DiscountCode');
  if (input) {
    input.value = '';
  }
}

/**
 * Restore floating-label state after cart DOM re-render.
 * Called via pub/sub cartUpdate and on co2.cart.initialized.
 */
async function restoreDiscountState() {
  if (typeof co2 === 'undefined') return;
  const code = await co2.getDiscountCode();
  if (!code) {
    clearActiveDiscountCode();
    return;
  }
  // DATORACODE - A/B-Test (CFSN-603): when the active code is the hidden auto-code,
  // render the field as empty (no value, no remove-X) — the discount still applies.
  if (typeof shouldHideAutoCode === 'function' && shouldHideAutoCode(code)) {
    clearActiveDiscountCode();
    return;
  }
  showActiveDiscountCode(code.trim().toUpperCase());
}
